export const NORM_LABELS: Record<string, string> = {
  ISO_13: 'ISO 27001:2013',
  ISO_22: 'ISO 27001:2022',
}

/** Returns a human-readable label for a norm key (e.g. ISO_13 → ISO 27001:2013). */
export const formatNormLabel = (norm: string): string =>
  NORM_LABELS[norm] ?? norm

/**
 * Maps a NormBase key (as stored in specifications) to the Standard string
 * used inside the RelatedControls array returned by the security control API.
 * e.g. ISO_13 → "ISO", ISO_22 → "ISO 2022"
 */
export const NORM_TO_RELATED_STANDARD: Record<string, string> = {
  ISO_13: 'ISO',
  ISO_22: 'ISO 2022',
}

export const normToRelatedStandard = (norm: string): string =>
  NORM_TO_RELATED_STANDARD[norm] ?? norm
